export const BUSINESS_TYPES = [
	'Electronics & Gadgets',
	'Fashion & Apparel',
	'Health & Beauty',
	'Home & Living',
	'Food & Beverages',
	'Automobile & Accessories',
	'Sports & Outdoor',
	'Books & Stationery',
	'Home Services & Repairs',
	'Computing & Software',
	'Real Estate & Properties',
	'Agriculture & Farming',
	'Handmade & Crafts',
	'Entertainment & Events',
	'Tutoring/Tutorial Centers',
];

export const BUSINESS_TYPE_CATEGORIES: Record<string, string[]> = {
	'Electronics & Gadgets': [
		'Mobile Phones & Accessories',
		'Laptops & Computers',
		'TV & Audio Equipment',
		'Gaming Consoles & Accessories',
	],
	'Fashion & Apparel': [
		"Men's Clothing",
		"Women's Clothing",
		'Shoes & Footwear',
		'Bags & Accessories',
		'Jewelry & Watches',
	],
	'Health & Beauty': [
		'Skincare & Cosmetics',
		'Haircare & Wigs',
		'Fragrances & Perfumes',
		'Personal Care & Hygiene',
		'Fitness & Supplements',
	],
	'Home & Living': [
		'Furniture & Decor',
		'Kitchen & Dining',
		'Bedding & Bath',
		'Home Appliances',
		'Lighting & Fixtures',
	],
	'Food & Beverages': [
		'Groceries & Packaged Foods',
		'Fresh Produce',
		'Drinks & Beverages',
		'Snacks & Confectionery',
	],
	'Automobile & Accessories': [
		'Cars & Motorcycles',
		'Car Accessories & Parts',
		'Oils & Fluids',
		'Tires & Wheels',
	],
	'Sports & Outdoor': [
		'Gym Equipment',
		'Sportswear & Footwear',
		'Outdoor & Camping Gear',
		'Bicycles & Accessories',
	],
	'Books & Stationery': [
		'Academic & Professional Books',
		'Novels & Magazines',
		'Office Supplies',
		'Art & Craft Supplies',
	],
	'Home Services & Repairs': [
		'Plumbing & Electrical Services',
		'Cleaning Services',
		'Home Renovation',
		'Pest Control',
	],
	'Computing & Software': [
		'Software & Digital Tools',
		'Website & App Development',
		'Cybersecurity Services',
		'IT Support & Maintenance',
	],
	'Real Estate & Properties': [
		'Rental Services',
		'Properties for Sale',
		'Property Management',
		'House Agent',
	],
	'Agriculture & Farming': [
		'Farming Equipment',
		'Seeds & Fertilizers',
		'Livestock & Poultry',
	],
	'Handmade & Crafts': [
		'Handmade Jewelry',
		'Custom Clothing',
		'Art & Decor',
		'Beadmaking',
	],
	'Entertainment & Events': [
		'Event Planning Services',
		'Music & DJ Services',
		'Photography & Videography',
	],
	'Tutoring/Tutorial Centers': ['Tutoring Services', 'Other'],
};

export const ALL_CATEGORIES = Array.from(
	new Set(Object.values(BUSINESS_TYPE_CATEGORIES).flat()),
);
